import { useState } from "react";
import { Box, Divider, Grid2, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import ModeButton from "./ModeButton";
import ScheduleButton from "./ScheduleButton";
import ChangelogButton from "./ChangelogButton";
import { SaveChangesButton } from "./SaveChangesButton";
import { RevertAllChangesButton } from "./RevertAllChangesButton";
import { getPlatform, useScreenOrientation } from "../../../utilities/orientationAndPlatform";


export default function SubHeaderBar({...params}){

    let pageMode = params.pageMode
    let setPageMode = params.setPageMode
    let channelData = params.channelData
    let isLive = params.isLive
    let logoURLState = params.logoURLState
    let userCanEdit = params.userCanEdit
    let handleSaveAllChangesClick = params.handleSaveAllChangesClick
    let handleRevertAllChangesClick = params.handleRevertAllChangesClick
    let updatedFieldsCountState = params.updatedFieldsCountState
    let storylineUuid = params.storylineUuid
    let userCanViewChangelog = params.userCanViewChangelog
    let theme = useTheme()
    let orientation = useScreenOrientation()
    let distributionUrl = params.distributionUrl
    let setShowVideoModal = params.setShowVideoModal

    let [modeButtonState, setModeButtonState] = useState('default')
    let [revertButtonState, setRevertButtonState] = useState('default')
    let [saveButtonState, setSaveButtonState] = useState('default')
    let [infoButtonState, setInfoButtonState] = useState('default')
    let [scheduleButtonState, setScheduleButtonState] = useState('default')
    let [changelogButtonState, setChangelogButtonState] = useState('default')

    function loadStationLogo(e) {
        e.target.onError = null;
        e.target.style.backgroundColor = '#007CEB';
        e.target.src = "/logos/sinclair-broadcast-group-white.svg";
    }

    let isNarrowDesktop = useMediaQuery('(max-width:1246px)')
    let platform = getPlatform()
    let subHeaderStackDirection = ''
    let subHeaderStackSpacing = ''
    let logoAlignment = ''
    let dividerVariant = ''
    if ((platform === 'mobile' && orientation === 0) || (platform === 'desktop' && isNarrowDesktop)) {
        subHeaderStackDirection = 'column'
        subHeaderStackSpacing = '15px'
        logoAlignment = 'center'
    }
    else if (platform === 'desktop' || (platform === 'mobile' && orientation === 90)) {
        subHeaderStackDirection = 'row'
        subHeaderStackSpacing = '20px'
    }

    let fontColor = theme.palette.ChannelPage.subheader.fontdefault

    return (
        <Grid2 position={'sticky'} top={'95px'} zIndex={10} display={'flex'} justifyContent={'stretch'} width={'100%'} backgroundColor={'ChannelPage.subheader.background'} sx={{borderBottom: '1px solid ' + theme.palette.ChannelPage.subheader.divider}} id={'SubHeaderBarGrid'}>
            
            <Stack direction={subHeaderStackDirection} spacing={subHeaderStackSpacing} sx={{ 
                width: '100%', 
                justifyContent: subHeaderStackDirection === 'row' ? 'space-between' : 'center', 
                alignItems: 'center',
                pr: subHeaderStackDirection === 'row' ? 5 : 0
            }}>
                <Box align={logoAlignment} height={'70px'} sx={{ width: subHeaderStackDirection === 'column' ? '100%' : 'auto' }}>
                    <Box
                        component="img"
                        src={logoURLState.imageSrc + '?' + logoURLState.imageHash + '.svg'}
                        alt="Station Logo"
                        onError={loadStationLogo}
                        sx={{
                            backgroundColor: "#007CEB",
                            padding: "15px",
                            height: "70px",
                            width: subHeaderStackDirection === 'column' ? '100%' : "182px",
                        }}
                    />
                </Box>

                {((platform === 'mobile' && orientation === 0) || (platform === 'desktop' && isNarrowDesktop)) ? (
                    <>
                        <Box display={'flex'} flexDirection={'row'} justifyContent={'center'} alignItems={'center'} width={'100%'}>
                            <Typography alignSelf={'center'} color={fontColor} fontSize={'18px'} fontWeight={400} paddingRight={'15px'}>{channelData.call_sign}</Typography>
                            <Divider orientation={'vertical'} flexItem variant={dividerVariant} sx={{backgroundColor: 'ChannelPage.subheader.mobiledivider'}} />
                            <Typography alignSelf={'center'} color={fontColor} fontSize={'18px'} fontWeight={400} paddingLeft={'21px'} paddingRight={'21px'}>{channelData.affiliation}</Typography>
                            <Divider orientation={'vertical'} flexItem variant={dividerVariant} sx={{backgroundColor: 'ChannelPage.subheader.mobiledivider'}} />
                            <Typography alignSelf={'center'} color={fontColor} fontSize={'18px'} fontWeight={400} paddingLeft={'21px'}>{channelData.market}</Typography>
                        </Box>

                          <ScheduleButton pageMode={pageMode} setPageMode={setPageMode} isLive={isLive} infoButtonState={infoButtonState} setInfoButtonState={setInfoButtonState}
                            scheduleButtonState={scheduleButtonState} setScheduleButtonState={setScheduleButtonState} storylineUuid={storylineUuid}/>
                        <Stack direction={'row'} spacing={3} alignSelf={'center'} paddingBottom={'17px'}>
                            {(userCanEdit) && (
                                <ModeButton
                                        pageMode={pageMode} 
                                        setPageMode={setPageMode} 
                                        modeButtonState={modeButtonState} 
                                        setModeButtonState={setModeButtonState}>
                                </ModeButton>
                            )}
                            <ChangelogButton 
                                    pageMode={pageMode} setPageMode={setPageMode} 
                                    changelogButtonState={changelogButtonState} setChangelogButtonState={setChangelogButtonState} 
                                    userCanViewChangelog={userCanViewChangelog}/>

                              {distributionUrl && (
                            <Box 
                                alignSelf={'center'} 
                                height={'35px'} 
                                width={'105px'} 
                                padding={'5px 10px'} 
                                sx={{
                                    backgroundColor: '#04569D',
                                    cursor: 'pointer',
                                    '&:hover': {
                                        backgroundColor: '#108DF9'
                                    }
                                }}
                                onClick={() => setShowVideoModal(true)}
                            >
                                <Typography 
                                    align={'center'} 
                                    color={theme.palette.ChannelPage.subheader.fontfilled} 
                                    fontSize={'18px'} 
                                    fontWeight={400}
                                >
                                    Live Stream
                                </Typography>
                            </Box>
                        )}        
                            
                            {(userCanEdit && pageMode === 'edit') && (
                                <>
                                    <SaveChangesButton handleSaveAllChangesClick={handleSaveAllChangesClick} updatedFieldsCountState={updatedFieldsCountState} saveButtonState={saveButtonState} setSaveButtonState={setSaveButtonState}/>
                                    <RevertAllChangesButton handleRevertAllChangesClick={handleRevertAllChangesClick} updatedFieldsCountState={updatedFieldsCountState} revertButtonState={revertButtonState} setRevertButtonState={setRevertButtonState}/>
                                </>
                            )}
                        </Stack>
                    </>
                )

                :(platform === 'desktop' || (platform === 'mobile' && orientation === 90)) && (
                    <>
                        <Typography alignSelf={'center'} color={fontColor} fontSize={'18px'} fontWeight={400}>{channelData.call_sign}</Typography>
                        <Divider orientation={'vertical'} sx={{backgroundColor: 'ChannelPage.subheader.desktopdivider'}} />
                        <Typography alignSelf={'center'} color={fontColor} fontSize={'18px'} fontWeight={400}>{channelData.affiliation}</Typography>
                        <Divider orientation={'vertical'} sx={{backgroundColor: 'ChannelPage.subheader.desktopdivider'}} />
                        <Typography alignSelf={'center'} color={fontColor} fontSize={'18px'} fontWeight={400}>{channelData.market}</Typography>
                        <Divider orientation={'vertical'} sx={{backgroundColor: 'ChannelPage.subheader.desktopdivider'}} />
                        <ScheduleButton pageMode={pageMode} setPageMode={setPageMode} isLive={isLive} infoButtonState={infoButtonState} setInfoButtonState={setInfoButtonState}
                            scheduleButtonState={scheduleButtonState} setScheduleButtonState={setScheduleButtonState} storylineUuid={storylineUuid}></ScheduleButton>
                        <Divider orientation={'vertical'} sx={{backgroundColor: 'ChannelPage.subheader.desktopdivider'}} />
                        <Stack direction={'row'} spacing={3} alignSelf={'center'}>
                            {(userCanEdit) && (
                                <ModeButton pageMode={pageMode} setPageMode={setPageMode} modeButtonState={modeButtonState} setModeButtonState={setModeButtonState}></ModeButton>
                            )}
                            <ChangelogButton pageMode={pageMode} setPageMode={setPageMode} 
                                changelogButtonState={changelogButtonState} setChangelogButtonState={setChangelogButtonState} 
                                userCanViewChangelog={userCanViewChangelog}/>
                                
                              {distributionUrl && (
                            <Box 
                                alignSelf={'center'} 
                                height={'35px'} 
                                width={'109px'} 
                                padding={'5px 10px'} 
                                sx={{
                                    backgroundColor: '#04569D',
                                    cursor: 'pointer',
                                    '&:hover': {
                                        backgroundColor: '#108DF9'
                                    }
                                }}
                                onClick={() => setShowVideoModal(true)}
                            >
                                <Typography 
                                    align={'center'} 
                                    color={theme.palette.ChannelPage.subheader.fontfilled} 
                                    fontSize={'16px'} 
                                    fontWeight={400}
                                >
                                    Live Stream
                                </Typography>
                            </Box>
                        )}

                            {(userCanEdit && pageMode === 'edit') && (
                                <>
                                    <SaveChangesButton handleSaveAllChangesClick={handleSaveAllChangesClick} updatedFieldsCountState={updatedFieldsCountState} saveButtonState={saveButtonState} setSaveButtonState={setSaveButtonState}/>
                                    <RevertAllChangesButton handleRevertAllChangesClick={handleRevertAllChangesClick} updatedFieldsCountState={updatedFieldsCountState} revertButtonState={revertButtonState} setRevertButtonState={setRevertButtonState}/>
                                </>
                            )}
                        </Stack>
                    </>
                )}
            </Stack>
        </Grid2>
    )
}
